module.exports = __webpack_public_path__ + "static/img/DO.58cff659.svg";